import { Dialog } from './types';

type DialogStoreItem = Dialog & { id: number };

export const createDialogStore = () => {
    let dialogs: DialogStoreItem[] = [];
    let subscribers = new Set<() => void>();

    const newId = () => Date.now();

    const add = (item: Dialog) => {
        const newItem = { id: newId(), ...item };
        dialogs = [...dialogs, newItem];

        subscribers.forEach((callback) => callback());

        return newItem;
    };
    const remove = (id: number) => {
        dialogs = [...dialogs.filter((item) => item.id !== id)];

        subscribers.forEach((callback) => callback());
    };

    return {
        add,
        remove,
        getDialogs: () => dialogs,
        getServerDialogs: () => dialogs,
        subscribe: (callback: () => void) => {
            subscribers.add(callback);
            return () => subscribers.delete(callback);
        },
    };
};
